// @flow
/**
 * @module Actions/Brand
 * @desc Brand Actions
 */
import { createActions } from 'redux-actions';

import { ActionTypes } from 'constants/index';

export const {
  getBrands,
  getBrand,
  getBrandsForFilter,
  getBrandMetrics,
  createBrand,
  editBrand,
  deleteBrand,
  getAdminsBrands,
  getAdminsAccounts,
  getAdminsLocations,
} = createActions({
  [ActionTypes.GET_BRANDS]: params => params,
  [ActionTypes.GET_BRAND]: id => ({ id }),
  [ActionTypes.GET_BRANDS_FOR_FILTER]: params => params,
  [ActionTypes.GET_BRAND_METRICS]: params => params,
  [ActionTypes.CREATE_BRAND]: data => data,
  [ActionTypes.EDIT_BRAND]: (id, brand) => ({ id, brand }),
  [ActionTypes.DELETE_BRAND]: id => ({ id }),
  [ActionTypes.GET_ADMINS_BRANDS]: () => ({}),
  [ActionTypes.GET_ADMINS_ACCOUNTS]: brandId => ({ brandId }),
  [ActionTypes.GET_ADMINS_LOCATIONS]: accountId => ({ accountId }),
});
